/**
 * Welcome email / SMS configuration (restaurant, partner, tenant onboarding).
 * Set in backend `.env` — SMTP required for real delivery.
 */
export const welcomeEmailConfig = {
  /** Master switch for welcome notifications on create flows */
  enabled: import.meta.env.VITE_WELCOME_EMAIL_ENABLED !== 'false',
  /** Shown in UI helper text and included in welcome email footers */
  supportEmail: (import.meta.env.VITE_SUPPORT_EMAIL || '').trim(),
  /** From address label (informational — actual send uses backend EMAIL_FROM / SMTP) */
  fromEmail: (import.meta.env.VITE_WELCOME_EMAIL_FROM || import.meta.env.VITE_SUPPORT_EMAIL || '').trim(),
};

export function isWelcomeEmailConfigured(): boolean {
  return welcomeEmailConfig.enabled && Boolean(welcomeEmailConfig.supportEmail);
}

export function welcomeEmailHelper(
  whenValid: 'email' | 'phone',
  server?: { supportEmail?: string; fromEmail?: string; ready?: boolean; smtpConfigured?: boolean },
): string {
  const support = (server?.supportEmail || welcomeEmailConfig.supportEmail || '').trim();
  const from = (server?.fromEmail || welcomeEmailConfig.fromEmail || support).trim();

  if (!welcomeEmailConfig.enabled) {
    return 'Welcome notifications are disabled in environment configuration.';
  }
  if (!support && !server?.smtpConfigured) {
    return 'Set VITE_SUPPORT_EMAIL in frontend .env and SUPPORT_EMAIL in backend .env to enable welcome messages.';
  }
  if (whenValid === 'email') {
    if (server?.ready || server?.smtpConfigured) {
      return `Valid registered email — welcome message will be sent on create (from ${from || support}).`;
    }
    return `Valid registered email — welcome message will be sent on create${from ? ` (from ${from})` : ''}.`;
  }
  if (server?.ready || server?.smtpConfigured) {
    return 'Valid registered number — welcome SMS will be sent on create when SMS is configured.';
  }
  return 'Valid registered number — welcome SMS will be sent on create when SMS is configured.';
}
